/**
 * @module JobList
 */
// eslint-disable-next-line no-unused-vars
import React from 'react';
import JobItem from './JobItem';
import JobSearchAssistance from './JobSearchAssistance';
import getOpenRolesLabel from '../helpers/getOpenRolesLabel';
import { STRINGS } from '../helpers/strings';

/**
 * Represents a section containing a list of jobs for Careers pages.
 *
 * @param {object} props - The component props object.
 * @param {Array<Job>} props.jobs - Array of job data objects.
 * @param {boolean} [props.showFallbackMessage] - Boolean value that indicates whether or not to show the fallback message.
 *
 * @returns {React.ReactElement} The JobList component.
 */
export default function JobList({ jobs, showFallbackMessage = false }) {
  const { main, prefix } = getOpenRolesLabel(jobs?.length);
  const showDefaultMessage = showFallbackMessage && jobs?.length === 0;

  return (
    <div className="job-list" data-testid="lc-job-list">
      <div className="job-list-items">
        <p className="jobs-list-count">
          {prefix} {main}
        </p>
        {jobs?.map((job) => (
          <JobItem job={job} key={`${job.title}_${job.teamTitle}`} />
        ))}
        {showDefaultMessage ? (
          <JobSearchAssistance messageToShow={STRINGS.messages.noAvailable} />
        ) : null}
      </div>
    </div>
  );
}
